import { render, staticRenderFns } from "./CircularCarouselView.vue?vue&type=template&id=174a2116&"
import script from "./CircularCarouselView.vue?vue&type=script&lang=ts&"
export * from "./CircularCarouselView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports